import { intercomConstants } from "@data/constants/intercomConstants"

export const resetIntercomIdentification = () => {
    return {
        type: intercomConstants.RESET_INTERCOM_IDENTIFICATION,
    }
}

export const setIntercomReady = (ready) => {
    return {
        type: intercomConstants.SET_INTERCOM_READY,
        ready,
    }
}

// Flags that the Intercom messenger should open as soon as its session is live
// (used when a support-reply push is tapped). The optional conversationId lands
// the user on the replied thread instead of the inbox. IntercomChat consumes and
// clears both.
export const setPendingIntercomOpen = (
    pending = true,
    conversationId = null
) => {
    return {
        type: intercomConstants.SET_PENDING_INTERCOM_OPEN,
        pending,
        conversationId,
    }
}

// Mirrors Intercom's unread conversation count into Redux so the help bubble can
// show an unread badge. IntercomChat keeps it in sync via the SDK's count events.
export const setIntercomUnreadCount = (count = 0) => {
    return {
        type: intercomConstants.SET_INTERCOM_UNREAD_COUNT,
        count,
    }
}
